export default __webpack_public_path__ + "static/media/screen2.252f0357.png";